var RequestFunction;
(function (RequestFunction) {
    RequestFunction["sign"] = "sign";
    RequestFunction["request"] = "request";
})(RequestFunction || (RequestFunction = {}));
var RequestMethod;
(function (RequestMethod) {
    RequestMethod["account"] = "account";
})(RequestMethod || (RequestMethod = {}));
export { RequestFunction, RequestMethod };
//# sourceMappingURL=type.js.map